<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="nlpost-card-header" class="pl-2 pr-3 small">
        <!-- {{ $moment().diff($moment(nlpost.timestamp,'DD/MM/YYYY HH:mm:SS'), 'minutes') }} -->
        NLPost
        <div class="card-header-actions">
          {{ nlpost.timestamp }}
          <span
            id="nlpost_ago"
            :class="'ml-2 status-dot ' + lastrunstatus"
            pulse="true"
          ></span>
        </div>
      </b-card-header>
      <b-tooltip target="nlpost-card-header" triggers="hover"
        >NL Post balancing the ledgers</b-tooltip
      >
      <b-tooltip target="nlpost_ago" triggers="hover"
        >last run
        {{
          $moment(nlpost.timestamp, "DD/MM/YYYY HH:mm:SS") | formatTimeago
        }}</b-tooltip
      >
      <b-card-body class="px-0 pt-0">
        <b-table
          v-if="nlpost.showtable"
          ref="logtable"
          id="logtable"
          striped
          sticky-header="205px"
          fixed
          small
          bordered
          :items="items"
          :fields="nlpost.fields"
          class="gridtable my-0"
        ></b-table>
        <b-row class="excelsheetbuttons">
          <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="nlpost_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="nlpost_log" triggers="hover"
                >Show log</b-tooltip
              >
            </b-button-group>
          </b-col>
          <b-col class="text-right">
            <b-link
              id="nlpost-start"
              :disabled="disabled"
              @click="action('start')"
              size="sm"
              class="mt-1 mr-2 text-primary"
            >
              <i class="fa fa-play"></i>
            </b-link>
            <b-tooltip target="nlpost-start" triggers="hover"
              >Start service</b-tooltip
            >

            <b-link
              id="nlpost-end"
              :disabled="disabled"
              @click="action('stop')"
              size="sm"
              class="mt-1 mr-2 text-danger"
            >
              <i class="fa fa-stop"></i>
            </b-link>
            <b-tooltip target="nlpost-end" triggers="hover"
              >Stop service</b-tooltip
            >
            <b-link
              id="nlpost-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Send to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="nlpost-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing last {{ nlpost.items.length }} message(s)</span
            >
            <br />
            <span v-if="!busy" class="small text-primary">{{
              nlpost.actionmessage
            }}</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "NLPost",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      disabled: true,
      name: "NLPost",
      nlpost: {
        // lastrunstatus: "success",
        timestamp: "Unknown",
        running: false,
        actionmessage: "",
        status: "negative",
        showtable: true,
        format: "grid",
        fields: [
          {
            key: "date",
            label: "Date and Time",
            sortable: true,
            sortDirection: "desc",
            class: "w-30pct",
          },
          {
            key: "message",
            label: "Message",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
        ],
        items: [
          {
            updated_at: this.$moment().format("x") / 1000,
            name: "Log4Net test message",
          },
        ],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      return this.nlpost.items;
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
    lastrunstatus() {
      let result = "danger";
      if (this.nlpost.timestamp != "Unknown") {
        let minutes = this.$moment().diff(
          this.$moment(this.nlpost.timestamp, "DD/MM/YYYY HH:mm:SS"),
          "minutes"
        );
        if (minutes <= 1440) {
          result = "success";
        } else if (minutes > 1440 && minutes < 2880) {
          result = "warning";
        } else {
          result = "danger";
        }
      }
      return result;
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: nlpostStatus:started");

      this.busy = true;
      let variables = {};
      variables.id = "nlpost_log";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_date($id: String) {
              file_date(id: $id)
            }
          `,
          variables,
        });
        if (response.data.file_date) {
          this.nlpost.timestamp = this.$moment
            .unix(response.data.file_date / 1000)
            .format("DD/MM/YYYY HH:mm:SS");

          try {
            const response = await this.$apollo.query({
              query: gql`
                query file_read($id: String) {
                  file_read(id: $id)
                }
              `,
              variables,
            });
            this.nlpost.items = [];
            let contents = JSON.parse(response.data.file_read);
            if (contents) {
              contents = contents.split("\n");
              for (var j = contents.length - 1; j >= 0; j--) {
                let log = contents[j].split(" - ");
                this.nlpost.items.push({ date: log[0], message: log[1] });
                if (j < contents.length - 299) {
                  break;
                }
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      } catch (error) {
        console.log(error);
      }
      console.log("loadChart: nlpostStatus:ended");

      this.busy = false;
      await this.$emit("refreshed");
    },

    async action(e) {
      console.log("action", e);
      let cmd = e;
      if (e.key) {
        cmd = e.key;
      }

      switch (cmd) {
        case "start":
          this.nlpost.running = true;
          // await this.exec("net start TravelPlacesProcessor");
          await this.exec("net start W3SVC");
          break;

        case "stop":
          this.nlpost.running = false;
          // await this.exec("net stop TravelPlacesProcessor");
          await this.exec("net stop W3SVC");
          break;

        case "refresh":
          await this.loadChart();
          break;
      }
    },
    async exec(e) {
      this.busy = true;
      let variables = {};
      variables.cmd = e;
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation ($cmd: String!) {
              exec(cmd: $cmd)
            }
          `,
          variables,
        });
        this.nlpost.actionmessage = response.data.exec;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
  },
};
</script>


<style>
</style>